import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { Divider, Stack } from '@mui/material';
import { SUPPORTED_CURRENCIES } from 'frontend/contexts/FlightsFiltersContext';
import { AccordionSection } from './AccordionSection';
import { ToggleSwitch } from './ToggleSwitch';

export const CurrencyFilter = ({
  dropdownState,
  toggleDropdown,
  currency,
  handleCurrencyChange,
  background,
}) => {
  return (
    <Stack gap={2}>
      <AccordionSection
        title="Moneda"
        isOpen={dropdownState.currency}
        onToggle={() => toggleDropdown('currency')}
      >
        <Stack gap={2}>
          {SUPPORTED_CURRENCIES.map((currencyCode) => (
            <ToggleSwitch
              key={currencyCode}
              isActive={currency === currencyCode}
              onChange={() => handleCurrencyChange(currencyCode)}
              label={currencyCode}
              icon={AttachMoneyIcon}
              background={background}
            />
          ))}
        </Stack>
      </AccordionSection>
      <Divider />
    </Stack>
  );
};
